import GET from "./api/GET";
import PUT from "./api/PUT";
import PATCH from "./api/PATCH";

export const profileDetails = async () => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/profile/details`
  );
  return response;
};

export const editEmployeeProfile = async (credentials) => {
  const response = await PUT(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/profile/update`,
    { ...credentials }
  );
  return response;
};

export const editEmployeePassword = async (credentials) => {
  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/employee/profile/update-password`,
    { ...credentials }
  );
  return response;
};
